﻿// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler';

// App imports.
//import listViewApp from './vue/listView';
import loginApp from './vue/login';
import forgotPasswordApp from './vue/forgotPassword';
import changePasswordApp from './vue/changePassword';
import userStateApp from './vue/userState';
import contactApp from './vue/contact';
import dashboardApp from './vue/dashboard';
import {
	dossierDetailAppLeft,
	dossierDetailAppRight,
} from './vue/dossierDetail';
import dossierDetailStore from './vue/store/dossierDetail.store';
import dashboardStore from './vue/store/dashboard.store';
import casesearchStore from './vue/store/casesearch.store';
import modalApp from './vue/modal';
import modalStore from './vue/store/modal.store';
import tableApp from './vue/table';

import claimCreateApp from './vue/claimCreate';
import claimDetailApp from './vue/claimDetail';
import userManagementApp from './vue/userManagement';
import headerSearchApp from './vue/headerSearch';
import caseSearchApp from './vue/caseSearch';
import menuApp from './vue/menu';

document.addEventListener('DOMContentLoaded', () => {
	const loginComponent = document.getElementById('loginForm');
	if (loginComponent) {
		createApp(loginApp).mount(loginComponent);
	}

	const passwordForgotComponent = document.getElementById('forgotPasswordForm');

	if (passwordForgotComponent) {
		createApp(forgotPasswordApp).mount(passwordForgotComponent);
	}

	const passwordChangeComponent = document.getElementById('change-pw');

	if (passwordChangeComponent) {
		createApp(changePasswordApp).mount(passwordChangeComponent);
	}

	const dashboardContainer = document.getElementById('dashboard');

	if (dashboardContainer) {
		const createdDashboardApp = createApp(dashboardApp);
		createdDashboardApp.use(dashboardStore);
		const dashboardDataset = dashboardContainer.dataset;
		dashboardStore.commit('setDictionary', Object.assign({}, dashboardDataset));
		createdDashboardApp.mount(dashboardContainer);
	}

	const tableContainers = document.querySelectorAll('.datatable-container');

	tableContainers.forEach((container) => {
		createApp(tableApp).mount(container);
	});

	const dossierDetailContainerLeft = document.getElementById('dossier-detail-left');

	if (dossierDetailContainerLeft) {
		const createdDossierDetailAppLeft = createApp(dossierDetailAppLeft);
		createdDossierDetailAppLeft.use(dossierDetailStore);
		const dossierDetailLeftDataset = dossierDetailContainerLeft.dataset;
		dossierDetailStore.commit('setLeftDictionary', Object.assign({}, dossierDetailLeftDataset));
		createdDossierDetailAppLeft.mount(dossierDetailContainerLeft);
	}

	const dossierDetailContainerRight = document.getElementById('dossier-detail-right');

	if (dossierDetailContainerRight) {
		const createdDossierDetailAppRight = createApp(dossierDetailAppRight);
		createdDossierDetailAppRight.use(dossierDetailStore);
		const dossierDetailRightDataset = dossierDetailContainerRight.dataset;
		dossierDetailStore.commit('setRightDictionary', Object.assign({}, dossierDetailRightDataset));
		createdDossierDetailAppRight.mount(dossierDetailContainerRight);
	}

	const userState = document.getElementById('userState');
	if (userState) {
		createApp(userStateApp).mount(userState);
	}

	const contact = document.getElementById('contactSwitch');
	if (contact) {
		createApp(contactApp).mount(contact);
	}

	const claimCreate = document.getElementById('claimCreate');
	if (claimCreate) {
		createApp(claimCreateApp).mount(claimCreate);
	}

	const claimDetail = document.getElementById('claimDetail');
	if (claimDetail) {
		const createdClaimDetailApp = createApp(claimDetailApp);
		createdClaimDetailApp.use(modalStore);
		const claimDetailDataset = claimDetail.dataset;
		modalStore.commit('setClaimDetailDictionary', Object.assign({}, claimDetailDataset));
		createdClaimDetailApp.mount(claimDetail);
	}

    const modal = document.getElementById('modal-wrapper');

    if (modal) {
        const createdModalApp = createApp(modalApp);
        createdModalApp.use(modalStore);
        createdModalApp.mount(modal);
    }

    const userManagment = document.getElementById('userManagement');

    if (userManagment) {
        const createdUserManagementApp = createApp(userManagementApp);
		createdUserManagementApp.use(modalStore);
		const userManagmentDataset = userManagment.dataset;
		modalStore.commit('setUserManagementDictionary', Object.assign({}, userManagmentDataset));
        createdUserManagementApp.mount(userManagment);
	}

	const headerSearch = document.getElementById('headerSearch');

	if (headerSearch) {
		const createdHeaderSearchApp = createApp(headerSearchApp);
		createdHeaderSearchApp.use(modalStore);
		createdHeaderSearchApp.mount(headerSearch);
	}

	const caseSearch = document.getElementById('caseSearch');

	if (caseSearch) {
		const createdCaseSearchApp = createApp(caseSearchApp);
		createdCaseSearchApp.use(casesearchStore);
		const casesearchDataset = caseSearch.dataset;
		casesearchStore.commit('setDictionary', Object.assign({}, casesearchDataset));
		createdCaseSearchApp.mount(caseSearch);
	}

	const mainmenu = document.getElementById('mainmenu');

	if (mainmenu) {
		createApp(menuApp).mount(mainmenu);
	}
});
